
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`So wie sich unsere Gesellschaft in Morgen- und Abendduscher teilen lässt, gibt es auch diejenigen, die mit offenem, und jene, die mit geschlossenem Fenster schlafen. Dabei handelt es sich aber nicht bloss um eine reine Glaubensfrage. `}<M mdxType="M">{`Viele Experten raten explizit, dass die Temperatur im Schlafzimmer zwischen 16 und 18 Grad liegen sollte, damit die Schlafenden weder schwitzen noch frieren. `}</M><br /><br />{`
Eine tiefere Temperatur und kühle Luft kann manchen Menschen beim Einschlafen helfen. Laut Albrecht Vorster, Autor des Buches «Warum wir schlafen», beeinflusst ein Temperaturabfall unsere innere Uhr. Sie signalisiert dem Körper, dass die Zeit zum Schlafen gekommen ist. Geschlossene Fenster können für manche Menschen aber durchaus sinnvoller sein – für Pollengeplagte etwa, oder für Menschen, die an stark frequentierten Strassen wohnen. Sicher aber gilt: Sorgen Sie durch Lüften vor dem Schlafengehen für frische Luft und ausreichend Sauerstoff im Schlafzimmer.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;